import { render, staticRenderFns } from "./NewPurchasePage.vue?vue&type=template&id=af08a7f2&scoped=true&"
import script from "./NewPurchasePage.vue?vue&type=script&lang=ts&"
export * from "./NewPurchasePage.vue?vue&type=script&lang=ts&"
import style0 from "./NewPurchasePage.vue?vue&type=style&index=0&id=af08a7f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af08a7f2",
  null
  
)

export default component.exports